export default __webpack_public_path__ + "static/media/background-circle-curtain-r5.e8518b77.svg";